export default "__VITE_ASSET__f076c1a8__"